// TODO: remove SEVERAL_RECURRENCE after deletion in basket and mobile-pro
export const SEVERAL_RECURRENCE = 'several';
